<!-- License Extension inline wizard. Theme-aware (uses --wg-* vars); becomes
     read-only when the message is past or the form was submitted. -->

@if (msg.licextFlowComplete) {
  <div class="licext-complete">
    <i class="pi pi-check-circle"></i>
    <div>
      <div class="licext-complete__title">Request submitted</div>
      <div class="licext-complete__sub">{{ completeSubMessage }}</div>
    </div>
  </div>

  <!-- Follow-up: offer another extension with the Device / SaaS choice pills. -->
  <div class="licext-followup">
    <div class="licext-followup__q">Is there anything else I can help you with? Would you like to do another extension?</div>
    <div class="licext-choice">
      <button type="button" class="licext-choicepill" [disabled]="locked || isProcessing" (click)="chooseType('device')">
        <i class="pi pi-desktop"></i> Device
      </button>
      <button type="button" class="licext-choicepill" [disabled]="locked || isProcessing" (click)="chooseType('saas')">
        <i class="pi pi-cloud"></i> SaaS
      </button>
    </div>
  </div>
}

@if (form && !msg.licextFlowComplete && flowType === 'type_choice') {
  <!-- Device-or-SaaS quick-reply pills, rendered under the agent's question. -->
  <div class="licext-choice">
    <button type="button" class="licext-choicepill" [disabled]="locked || isProcessing" (click)="chooseType('device')">
      <i class="pi pi-desktop"></i> Device
    </button>
    <button type="button" class="licext-choicepill" [disabled]="locked || isProcessing" (click)="chooseType('saas')">
      <i class="pi pi-cloud"></i> SaaS
    </button>
  </div>
}

@if (form && !msg.licextFlowComplete && flowType !== 'type_choice') {
  <div class="licext-card" [class.licext-card--locked]="locked"
       [class.licext-card--wide]="flowType === 'saas_step2' || flowType === 'select_approvers'"
       [class.licext-card--medium]="flowType === 'device_step2'"
       [class.licext-card--narrow]="flowType === 'device_step1' || flowType === 'saas_step1'">
    <div class="licext-card__header">
      <i class="pi pi-file-edit"></i>
      <span>
        @switch (flowType) {
          @case ('device_step1') { Device License Extension — Serial Numbers }
          @case ('device_step2') { Device License Extension — Select SKUs }
          @case ('saas_step1') { SaaS License Extension — Container Keys }
          @case ('saas_step2') { SaaS License Extension — Select Products }
          @case ('select_approvers') { License Extension — Select Approvers }
        }
      </span>
    </div>

    <div class="licext-card__body">

      <!-- ── Approver selection wizard ── -->
      @if (flowType === 'select_approvers') {
        <span class="licext-s1hint">Select the approver(s) you want to notify and click Send for Approval.</span>
        <app-licext-approver-picker
          [approvers]="approverList"
          [locked]="locked"
          [preselectedEmails]="approverPreselected"
          (send)="submitApprovers($event)" />
      }

      <!-- ── Device step 1 (serial collection) ── -->
      @if (flowType === 'device_step1') {
        <span class="licext-s1hint">Enter up to {{ MAX_ROWS }} device serial numbers — leave any extra rows blank.</span>
        <div class="licext-s1list">
          @for (row of deviceStep1Rows(); track trackByIndex($index); let i = $index) {
            <div class="licext-s1item">
              <div class="licext-s1row">
                <span class="licext-s1row__num">{{ i + 1 }}</span>
                <input class="licext-input" [class.licext-input--error]="row.invalid" type="text"
                       [value]="row.serial" [disabled]="locked" placeholder="Serial number"
                       (input)="updateDeviceSerial(i, $any($event.target).value)" />
              </div>
              @if (row.invalid && row.error) {
                <span class="licext-rowerr"><i class="pi pi-exclamation-circle"></i> {{ row.error }}</span>
              }
            </div>
          }
        </div>

        <div class="licext-card__actions">
          @if (!locked && duplicateSerials) {
            <span class="licext-hint licext-hint--warn">Duplicate serial numbers — each must be unique.</span>
          }
          <button type="button" class="licext-btn licext-btn--primary"
                  [disabled]="locked || !deviceStep1Valid || isProcessing" (click)="submitDeviceStep1()">
            Continue
          </button>
        </div>
      }

      <!-- ── Device step 2 (per-device SKU selection) ── -->
      @if (flowType === 'device_step2') {
        <div class="licext-step2head">
          <span class="licext-step2head__hint">Pick an extension SKU for each device.</span>
          @if (!locked) {
            <button type="button" class="licext-btn licext-btn--neutral licext-btn--sm" (click)="editSerials()">
              <i class="pi pi-arrow-left"></i> Edit serials
            </button>
          }
        </div>
        <div class="licext-step2grid">
        @for (row of deviceStep2Rows(); track trackByIndex($index); let rowIdx = $index) {
          <div class="licext-d2row">
            <div class="licext-d2row__keys">
              <div class="licext-d2field">
                <span class="licext-d2field__lbl">Device ID:</span>
                <span class="licext-d2field__val">{{ row.serial }}</span>
              </div>
              <div class="licext-d2field">
                <span class="licext-d2field__lbl">Account ID:</span>
                <span class="licext-d2field__val">{{ row.accountId }}</span>
              </div>
            </div>
            <div class="licext-d2row__sel">
              <label class="licext-label">SKU <span class="licext-req">*</span></label>
              @if (!row.skus.length) {
                <div class="licext-empty">No extension SKUs available for this device.</div>
              } @else {
                <!-- Searchable per-device SKU combobox (type to filter). -->
                <div class="licext-combo licext-combo--block">
                  <button type="button" class="licext-combo__trigger"
                          [class.licext-combo__trigger--placeholder]="!row.selectedSku"
                          [class.licext-combo__trigger--open]="openSkuRow() === rowIdx"
                          [disabled]="locked" (click)="toggleSkuPanel(rowIdx)">
                    <span class="licext-combo__val">{{ selectedLabel(row) || 'Select SKU…' }}</span>
                    @if (row.selectedSku && !locked) {
                      <i class="pi pi-times licext-combo__clear" title="Clear"
                         (click)="$event.stopPropagation(); clearSku(rowIdx)"></i>
                    } @else {
                      <i class="pi licext-combo__chev"
                         [class.pi-chevron-down]="openSkuRow() !== rowIdx"
                         [class.pi-chevron-up]="openSkuRow() === rowIdx"></i>
                    }
                  </button>
                  @if (openSkuRow() === rowIdx && !locked) {
                    <div class="licext-combo__panel licext-combo__panel--block">
                      <input class="licext-input licext-combo__search" type="text" [value]="skuQuery()"
                             placeholder="Search SKU…" (input)="onSkuSearch($any($event.target).value)"
                             (keydown)="onSkuKeydown(rowIdx, $event)" />
                      <div class="licext-combo__list">
                        @for (s of filteredSkus(rowIdx); track trackByIndex($index); let skuIdx = $index) {
                          <button type="button" class="licext-combo__opt"
                                  [class.licext-combo__opt--on]="row.selectedSku === s.sku"
                                  [class.licext-combo__opt--active]="skuActiveIdx() === skuIdx"
                                  (click)="selectSku(rowIdx, s.sku || '')">{{ skuLabel(s) }}</button>
                        }
                        @if (!filteredSkus(rowIdx).length) {
                          <div class="licext-empty">No matching SKU.</div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        </div>

        <label class="licext-label">Account Name <span class="licext-req">*</span></label>
        <input class="licext-input" type="text" [value]="accountName()" [disabled]="locked"
               placeholder="Account name (required)"
               (input)="onAccountNameInput($event)" />

        <label class="licext-label">Reason <span class="licext-req">*</span></label>
        <textarea class="licext-input licext-textarea" rows="2" [value]="reason()" [disabled]="locked"
                  placeholder="Why is this extension needed? (required)"
                  (input)="onReasonInput($event)"></textarea>
        <span class="licext-counter" [class.licext-counter--over]="wordCount() > REASON_MAX_WORDS">
          {{ wordCount() }} / {{ REASON_MAX_WORDS }} words
        </span>

        <div class="licext-card__actions">
          <button type="button" class="licext-btn licext-btn--primary"
                  [disabled]="locked || !deviceStep2Valid || isProcessing" (click)="submitDeviceStep2()">
            Submit
          </button>
        </div>
      }

      <!-- ── SaaS step 1 ── -->
      @if (flowType === 'saas_step1') {
        <span class="licext-s1hint">Enter up to {{ MAX_ROWS }} container activation keys — leave any extra rows blank.</span>
        <div class="licext-s1list">
          @for (row of saasStep1Rows(); track trackByIndex($index); let i = $index) {
            <div class="licext-s1item">
              <div class="licext-s1row">
                <span class="licext-s1row__num">{{ i + 1 }}</span>
                <input class="licext-input" type="text" [value]="row.containerKey" [disabled]="locked"
                       placeholder="Container activation key"
                       (input)="updateSaasRow(i, $any($event.target).value)" />
              </div>
            </div>
          }
        </div>

        <div class="licext-card__actions">
          @if (!locked && duplicateContainerKeys) {
            <span class="licext-hint licext-hint--warn">Duplicate container keys — each must be unique.</span>
          }
          <button type="button" class="licext-btn licext-btn--primary"
                  [disabled]="locked || !saasStep1Valid || isProcessing" (click)="submitSaasStep1()">
            Continue
          </button>
        </div>
      }

      <!-- ── SaaS step 2 (product selection) ── -->
      @if (flowType === 'saas_step2') {
        <div class="licext-step2head">
          <span class="licext-step2head__hint">Pick products and an extension length for each container.</span>
          @if (!locked) {
            <button type="button" class="licext-btn licext-btn--neutral licext-btn--sm" (click)="editContainerKeys()">
              <i class="pi pi-arrow-left"></i> Edit container keys
            </button>
          }
        </div>
        <div class="licext-step2grid">
        @for (row of saasStep2Rows(); track trackByIndex($index); let rowIdx = $index) {
          <div class="licext-d2row licext-d2row--saas">
            <div class="licext-d2row__keys">
              <!-- Container key is a long UUID → stacked (label above value). -->
              <div class="licext-saasfield">
                <span class="licext-saasfield__lbl">Container Key</span>
                <span class="licext-saasfield__val">{{ row.containerKey }}</span>
              </div>
              <!-- Account ID is short → inline "Account ID: <value>" to save height. -->
              <div class="licext-d2field">
                <span class="licext-d2field__lbl">Account ID:</span>
                <span class="licext-d2field__val">{{ row.accountId }}</span>
              </div>
            </div>
            <div class="licext-d2row__sel">
              <label class="licext-label">Products <span class="licext-req">*</span></label>
              @if (!row.products.length) {
                <div class="licext-empty">No products found for this container.</div>
              } @else {
                <!-- A container can hold many products, so the list lives in an
                     overlay dropdown; ticking a product reveals its 7/14/30 pills. -->
                <div class="licext-combo licext-combo--block">
                  <button type="button" class="licext-combo__trigger"
                          [class.licext-combo__trigger--placeholder]="rowSelectedCount(row) === 0"
                          [class.licext-combo__trigger--open]="row.panelOpen"
                          [disabled]="locked" (click)="togglePanel(rowIdx)">
                    <span class="licext-combo__val">{{ saasProductsLabel(row) }}</span>
                    <i class="pi" [class.pi-chevron-down]="!row.panelOpen" [class.pi-chevron-up]="row.panelOpen"></i>
                  </button>
                  @if (row.panelOpen) {
                    <div class="licext-combo__panel licext-combo__panel--block">
                      <div class="licext-combo__list">
                        @for (p of row.products; track trackByIndex($index); let pIdx = $index) {
                          <div class="licext-comboproduct">
                            <label class="licext-check">
                              <input type="checkbox" [checked]="isProductSelected(rowIdx, pIdx)" [disabled]="locked"
                                     (change)="toggleProduct(rowIdx, pIdx)" />
                              <span>{{ p.product_name || '(unnamed product)' }}</span>
                            </label>
                            @if (p.expiration_date) {
                              <div class="licext-comboproduct__exp"><strong>Exp. Date:</strong> {{ formatExpiry(p.expiration_date) }}</div>
                            }
                            @if (isProductSelected(rowIdx, pIdx)) {
                              <div class="licext-days">
                                @for (d of saasDayOptions(); track d) {
                                  <button type="button" class="licext-pill"
                                          [class.licext-pill--on]="row.selected[pIdx] === d" [disabled]="locked"
                                          (click)="setDays(rowIdx, pIdx, d)">{{ d }}d</button>
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
        </div>

        <div class="licext-hint" [class.licext-hint--warn]="selectedCount > 5">
          {{ selectedCount }}/5 products selected
        </div>

        <label class="licext-label">Account Name <span class="licext-req">*</span></label>
        <input class="licext-input" type="text" [value]="accountName()" [disabled]="locked"
               placeholder="Account name (required)"
               (input)="onAccountNameInput($event)" />

        <label class="licext-label">Reason <span class="licext-req">*</span></label>
        <textarea class="licext-input licext-textarea" rows="2" [value]="reason()" [disabled]="locked"
                  placeholder="Why is this extension needed? (required)"
                  (input)="onReasonInput($event)"></textarea>
        <span class="licext-counter" [class.licext-counter--over]="wordCount() > REASON_MAX_WORDS">
          {{ wordCount() }} / {{ REASON_MAX_WORDS }} words
        </span>

        <div class="licext-card__actions">
          <button type="button" class="licext-btn licext-btn--primary"
                  [disabled]="locked || !saasStep2Valid || isProcessing" (click)="submitSaasStep2()">
            Submit
          </button>
        </div>
      }

    </div>
  </div>
}
